import React from "react";
import images from "../../../utilities/images/images";
import resumeEmptyBoxIcon from "../../../utilities/images/study_dashboard/resume_empty_box_icon.svg";

const RESUME_ICONS = {
  video: images.resume_video_icon,
  practice: images.resume_note_icon,
  test: images.resume_note_icon,
  legacy_exam: images.resume_note_icon,
};

const ResumeEmptyState = () => (
  <div className="study-dashboard__resume-empty" role="status">
    <img
      src={resumeEmptyBoxIcon}
      alt=""
      className="study-dashboard__resume-empty-icon"
      aria-hidden="true"
    />
    <div className="study-dashboard__resume-empty-copy">
      <p className="study-dashboard__resume-empty-title">No unfinished activities</p>
      <p className="study-dashboard__resume-empty-description">
        Start preparing for your target by watching videos, taking practice and test
      </p>
    </div>
  </div>
);

const ResumeCard = ({ item, onAction }) => {
  const progress = Math.min(100, Math.max(0, Number(item.progress) || 0));
  const iconSrc = item.icon || RESUME_ICONS[item.type] || RESUME_ICONS.video;

  return (
    <article className="study-dashboard__resume-card" role="listitem">
      <div className="study-dashboard__resume-card-content">
        <div className="study-dashboard__resume-card-top">
          <div
            className={`study-dashboard__resume-icon study-dashboard__resume-icon--${item.type}`}
          >
            <img src={iconSrc} alt="" aria-hidden="true" />
          </div>
          <div className="study-dashboard__resume-card-text">
            <h3>{item.title}</h3>
            <p>{item.subtitle}</p>
          </div>
        </div>
        <div className="study-dashboard__resume-card-progress">
          <p className="study-dashboard__resume-remaining">{item.remainingLabel}</p>
          <div className="study-dashboard__resume-progress-track" aria-hidden="true">
            <div
              className="study-dashboard__resume-progress-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
      <button type="button" className="study-dashboard__resume-btn" onClick={onAction}>
        <img src={images.resume_play_icon} alt="" aria-hidden="true" />
        <span className="study-dashboard__resume-btn-label">{item.actionLabel}</span>
      </button>
    </article>
  );
};

const ResumeSection = ({ items = [], onResume, isLoading = false }) => {
  const hasItems = items.length > 0;
  const showEmpty = !hasItems && !isLoading;

  if (!hasItems && !showEmpty) return null;

  return (
    <section
      className={`study-dashboard__resume${
        showEmpty ? " study-dashboard__resume--empty" : ""
      }`}
      aria-labelledby="resume-section-title"
    >
      <div
        className={`study-dashboard__resume-inner${
          showEmpty ? " study-dashboard__resume-inner--empty" : ""
        }`}
      >
        <div className="study-dashboard__resume-header">
          <div className="study-dashboard__resume-pill">
            <img src={images.resume_sparks_icon} alt="" aria-hidden="true" />
            Continue Your Learning
          </div>
          <h2 id="resume-section-title">Resume Where You Left Off</h2>
        </div>
        {hasItems ? (
          <div className="study-dashboard__resume-track" role="list">
            {items.map((item) => (
              <ResumeCard
                key={item.id}
                item={item}
                onAction={() => onResume(item)}
              />
            ))}
          </div>
        ) : (
          <ResumeEmptyState />
        )}
      </div>
    </section>
  );
};

export default ResumeSection;
